module.exports = __webpack_public_path__ + "img/emerson.dc97bc34.png";